module.exports = __webpack_public_path__ + "img/car3.61a05375.png";